export const MapMarkersTypes = {
  HealthCenterSearch: {
    width: '22px',
    height: '31px',
    url: 'assets/images/brown-pin.png'
  },
  GeneralSearch: {
    width: '27px',
    height: '30px',
    url: 'assets/images/SearchPin.png'
  },
  General: {
    width: '14px',
    height: '14px',
    url: 'assets/images/MapMarker.png'
  },
  Selected: {
    width: '22px',
    height: '31px',
    url: 'assets/images/MapMarkerActive.png'
  }
};
